/**
 * For more information on the flows, please refer to the following documentation:
 * For more information see: https://workivate.atlassian.net/wiki/spaces/WT/pages/5550243882/USL+Login+Flows
 */
export enum FLOW {
  WAM_SUBDOMAIN = 'WAM_SUBDOMAIN',
  X_USL_OTT = 'X_USL_OTT',
  TOKEN = 'TOKEN',
  USERTOKEN_AND_OTT = 'USERTOKEN_AND_OTT',
  USERTOKEN = 'USERTOKEN',
  USL_AUTH = 'USL_AUTH',
  AUTH_PARAMS = 'AUTH_PARAMS',
  AUTH_CHECK = 'AUTH_CHECK',
  AUTHENTICATED_REDIRECT_NEEDED = 'AUTHENTICATED_REDIRECT_NEEDED',
  AUTHENTICATED_NO_REDIRECT_NEEDED = 'AUTHENTICATED_NO_REDIRECT_NEEDED',
  AUTHENTICATED_SHOULD_NOT_REDIRECT = 'AUTHENTICATED_SHOULD_NOT_REDIRECT',
  NOT_AUTHENTICATED = 'NOT_AUTHENTICATED',
  SIGNUP_IDP_SSO = 'SIGNUP_IDP_SSO', // IDP-initiated sign up
  SIGNUP_INVITATION_CODE = 'SIGNUP_INVITATION_CODE', // Invitation code sign up
}

/**
 * List of query parameters that should be excluded from URL persistence and redirects
 * These parameters are used for authentication and should not be passed in redirects or stored
 * 'code' and 'state' are received from BE after we have successfully logged in to USL
 * since we are already authenticated we don't need to pass them again
 * 'x-usl-ott' is used for SSOX and is not needed in the final redirect
 */
export const EXCLUDE_FROM_AUTHENTICATED_REDIRECT = [
  'code', // OAuth authorization code
  'state', // OAuth state parameter
  'x-usl-ott', // USL one-time token
  'userToken', // User authentication token
  'ott', // One-time token
  'token', // IDP Initiated SSO token
  'tenancy_hash', // used by BE
  'tenancyHash', // used by FE
];

/**
 * List of query parameters that should be excluded from redirects to a stored original path
 * If the user followed a link with a path like /some-path?code=abc&state=xyz
 * we will redirect them to that path after login or signup
 * Auth is already done so we need to remove auth params from the URL
 */
export const EXCLUDE_FROM_ORIGINAL_PATH = [
  ...EXCLUDE_FROM_AUTHENTICATED_REDIRECT,
  'refreshToken', // Refresh token for session management',
  'clientId', // Client ID for OAuth
];

/**
 * Query parameters to preserve when on root path (/)
 * These params are stored separately because root paths are not stored in originalPath
 * but we need to preserve certain params for external authentication flows (e.g., Zendesk)
 * The router's checkZendeskRedirect() function will detect return_to and redirect accordingly
 */
export const PRESERVE_ON_ROOT_PATH = ['return_to'];
